exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html{height:100%;font-family:sans-serif}body{background-color:#101012;color:#ddd;height:100%}#root{width:100%;height:100%}", ""]);

